import React, { useState } from 'react';
import useDataSource from '@afosto/app-components-react/DataSource/useDataSource';
import useInstallApp from '../../../utils/useInstallApp';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { useSnackbar } from 'notistack';
import Grid from '@material-ui/core/Grid';
import CreateIntegrationDrawer from '../CreateIntegrationDrawer';
import App from './App';
import AppSkeleton from './AppSkeleton';
import DataList from '@afosto/app-components-react/DataList';
import dataSourceRequest from '@afosto/utils-react/dataSource/dataSourceRequest';
import isDefined from '@afosto/utils/isDefined';
import sortArrayByProperty from '@afosto/utils/array/sortArrayByProperty';
import { apps as appsApi } from '@afosto/apps/api/Apps';
import { integrations as integrationsApi } from '@afosto/apps/api/Integrations';
import translations from './translations';

const DataListGridContainer = props => <Grid container spacing={1} {...props} />;

const AppsList = () => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [app, setApp] = useState(null);
  const [showCreateIntegrationDrawer, setShowCreateIntegrationDrawer] = useState(false);
  const installApp = useInstallApp();

  const fetchApps = async dataSource =>
    dataSourceRequest(
      dataSource,
      async (source, requestOptions) => appsApi.listApps(requestOptions),
      {
        transformData: data => sortArrayByProperty(data, 'name'),
      },
    );

  const dataSource = useDataSource(fetchApps, {
    modules: ['pagination'],
    pagination: {
      itemsPerPage: 100,
    },
  });

  const handleAddApp = async selectedApp => {
    if (!selectedApp.is_duplicate_allowed) {
      const response = await integrationsApi
        .listIntegrations({ appCode: selectedApp.code })
        .catch(() => {});
      const { data: integrations = [] } = response ?? {};

      if (integrations?.length > 0) {
        enqueueSnackbar(intl.formatMessage(translations.feedback.integrationAlreadyAdded), {
          variant: 'warning',
        });
        return;
      }
    }

    if (!isDefined(selectedApp?.config_schema)) {
      installApp(selectedApp, {
        name: selectedApp?.name,
        credentials: {},
        configuration: {},
      }).catch(() => {});
    } else {
      setApp(selectedApp);
      setShowCreateIntegrationDrawer(true);
    }
  };

  const renderApp = item => <App key={item.code} app={item} onAdd={handleAddApp} />;

  const renderAppSkeleton = key => <AppSkeleton key={key} />;

  return (
    <>
      <DataList
        component={DataListGridContainer}
        dataSource={dataSource}
        emptyMessage={intl.formatMessage(translations.emptyMessage)}
        renderItem={renderApp}
        renderSkeletonItem={renderAppSkeleton}
      />
      <CreateIntegrationDrawer
        isOpen={showCreateIntegrationDrawer}
        onClose={() => {
          setShowCreateIntegrationDrawer(false);
          setApp(null);
        }}
        app={app}
      />
    </>
  );
};

export default AppsList;
